/* eslint-disable no-template-curly-in-string */
/* AUTH API STARTS */
export const API_SIGNIN_ENDPOINT = "/sign-in";
export const API_SIGNUP_ENDPOINT = "/register";
export const API_VERIFYOTP_ENDPOINT = "/verify-phone";
export const API_RESENDOTP_ENDPOINT = "/resend-phone-verification";
export const API_VERIFYEMAIL_ENDPOINT = "/verify-email";
export const API_VALIDATE_EMAIL_OTP_ENDPOINT = "/validate-email-token";
export const API_RESENDEMAILVERIFICATION_ENDPOINT =
  "/resend-email-verification";
export const API_MFASIGNIN_ENDPOINT = "/mfa-sign-in";
export const API_FORGOT_PASSWORD_ENDPOINT = "/forgot-password";
export const API_CHANGE_PASSWORD_ENDPOINT = "/reset-password";
export const API_PROFILE_ENDPOINT = "/profile";
export const API_WALLET_DETAILS_ENDPOINT = "/wallet-details";
export const API_CREATE_USER_ENDPOINT = "/create-user";
export const API_UPDATE_PROFILE_ENDPOINT = "/update-profile";
export const API_UPDATE_USER_STATUS_ENDPOINT = "/update-user-status";
export const API_POST_UPDATE_STATUS = "/update-user-status";
export const API_LOGOUT_ENDPOINT = "/logout";

/* AUTH API ENDS */

/* ADMIN API STARTS */
export const API_GETUPLOADURL_ENDPOINT = "/get-url-for-upload";
export const API_CREATE_CATEGORY_ENDPOINT = "/create-category";
export const API_UPDATE_CATEGORY_ENDPOINT = "/update-category";
export const API_LIST_USERS_ENDPOINT = "/list-users";
export const API_DELETE_USER_ENDPOINT = "/user";

export const API_CREATE_API_ENDPOINT = "/create-api";
export const API_UPDATE_API_ENDPOINT = "/update-api";
export const API_CHANGE_API_STATUS_ENDPOINT = "/update-api-status";
export const API_LIST_ACTIVITIES_ENDPOINT = "/list-activities";
export const API_GET_ACTIVITY_ENDPOINT = "/activity";
export const API_LIST_FEEDBACK_ENDPOINT = "/list-feedback";
export const API_GET_FEEDBACK_ENDPOINT = "/feedback";
export const API_GET_CREDIT_CONFIG = "/global-credit-details";
export const API_PUT_CREDIT_CONFIG = "/configure-credit";
export const API_GET_CREDIT_FOR_MODAL = "/credit-user";
export const API_LIST_KEY_VALUE_PAIR = "/list-portal-secrets";
export const API_CREATE_KEY_VALUE_PAIR = "/create-portal-secret";
export const API_GET_KEY_VALUE_PAIR = "/portal-secret";
export const API_UPDATE_KEY_VALUE_PAIR = "/update-portal-secret";

export const API_CREATE_API_GATEWAY_STAGE_ENDPOINT = "/api-gateway-stage";
export const API_GET_API_GATEWAY_STAGE_ENDPOINT = "/api-gateway-stage";
export const API_UPDATE_API_GATEWAY_STAGE_ENDPOINT = "/api-gateway-stage";
export const API_LIST_API_GATEWAY_STAGE_ENDPOINT = "/list-api-gateway-stages";

export const API_CREATE_API_GATEWAY_ENDPOINT = "/api-gateway";
export const API_GET_API_GATEWAY_ENDPOINT = "/api-gateway";
export const API_UPDATE_API_GATEWAY_ENDPOINT = "/api-gateway";
export const API_LIST_API_GATEWAY_ENDPOINT = "/list-api-gateways";

export const API_CREATE_CERTIFICATE_ENDPOINT = "/certificate";
export const API_UPDATE_CERTIFICATE_ENDPOINT = "/certificate";
export const API_LIST_CERTIFICATE_ENDPOINT = "/list-certificates";
export const API_GET_CERTIFICATE_ENDPOINT = "/certificate";
export const API_DELETE_CERTIFICATE_ENDPOINT = "/certificate";

export const API_POST_SETSTATUS = "/update-category-status";

export const API_LIST_CUSTOMER_ENDPOINT = "/list-customer-endponts-mapping";
export const API_GET_CUSTOMER_ENDPOINT = "/customer-endponts-mapping";
export const API_CREATE_CUSTOMER_ENDPOINT = "/create-customer-endponts-mapping";
export const API_UPDATE_CUSTOMER_ENDPOINT = "/update-customer-endponts-mapping";
export const API_UPDATE_STATUS_CUSTOMER_ENDPOINT =
  "/update-status-customer-endponts-mapping";

export const API_CREATE_SCHEDULED_JOB_ENDPOINT = "/create-scheduled-job";
export const API_UPDATE_SCHEDULED_JOB_ENDPOINT = "/update-scheduled-job";
export const API_UPDATE_SCHEDULED_JOB_STATUS_ENDPOINT =
  "/update-scheduled-job-status";
export const API_LIST_SCHEDULED_JOB_ENDPOINT = "/list-scheduled-jobs";
export const API_GET_SCHEDULED_JOB_ENDPOINT = "/scheduled-job";

export const API_CREATE_WORKFLOW_ENDPOINT = "/create-workflow";
export const API_UPDATE_WORKFLOW_ENDPOINT = "/update-workflow";
export const API_UPDATE_WORKFLOW_STATUS_ENDPOINT = "/update-workflow-status";
export const API_LIST_WORKFLOW_ENDPOINT = "/list-workflows";
export const API_GET_WORKFLOW_ENDPOINT = "/workflow";
export const API_CHECK_API_ENDPOINT_AVAILABILITY_ENDPOINT =
  "/check-api-endpoint-availability";
export const API_ATLAS_SETTINGS_ENDPOINT = "/atlas-settings";
export const API_ATLAS_SETTINGS_LOG_RETENTION_POLICY_ENDPOINT =
  "/atlas-settings?connector-logs-lifecycle-management-policy=true";
/* ADMIN API ENDS */

/* GATEWAY API STARTS */
export const API_GATEWAY_PROXY_CLIENT_API_ENDPOINT =
  "/proxy-client/atlas/internal/service";
export const API_GATEWAY_PROXY_WORKFLOW_EXECUTOR_API_ENDPOINT =
  "/workflow-client/atlas/internal/service";
/* GATEWAY API ENDS */

/* PORTAL API STARTS */
export const API_LIST_CATEGORIES_OPEN_ENDPOINT = "/open/list-categories";
export const API_LIST_CATEGORIES_ENDPOINT = "/list-categories";
export const API_GET_CATEGORY_ENDPOINT = "/category";
export const API_GET_CATEGORY_OPEN_ENDPOINT = "/open/category";
export const API_LISTING_ENDPOINT = "/list-api";
export const API_LISTING_OPEN_ENDPOINT = "/open/list-api";
export const API_GET_API_BY_ID_ENDPOINT = "/api";
export const API_GET_API_BY_ID_OPEN_ENDPOINT = "/open/api";
export const API_GLIMPSE_ENDPOINT = "/glimpse";
export const API_GET_OVERALL_APIS_ENDPOINT = "/overall-apis-consumptions";
export const API_GET_TOP_APIS_ENDPOINT = "/top-apis-consumptions";
export const API_GET_OVERALL_APIS_CONSUMERS_ENDPOINT =
  "/overall-apis-consumers";
export const API_TRIGGER_REPORT_DOWNLOAD_ENDPOINT = "/generate-reports";
export const API_GET_TOP_APIS_CONSUMERS_ENDPOINT = "/top-apis-consumers";
export const API_GET_API_CONSUMPTION_ANALYTICS_ENDPOINT =
  "/api-consumption-analytics";
export const API_GET_API_CONSUMPTION_METRICS_ENDPOINT = "/consumption-details";
export const API_GET_WORKFLOW_EXECUTION_ANALYTICS_ENDPOINT =
  "/workflow-execution-analytics";
export const API_GET_SCHEDULED_JOB_ANALYTICS_ENDPOINT =
  "/scheduled-job-execution-analytics";
export const API_GET_API_LATENCY_ANALYTICS_ENDPOINT = "/api-latency-analytics";
export const API_GET_USER_ANALYTICS_ENDPOINT = "/get-user-analytics";
export const API_LIST_USER_APIACCESS_DETAILS_ENDPOINT = "/list-api-access";
export const API_LIST_API_SUBSCRIPTIONS = "/api-subscriptions-detail";
export const API_GET_APPLICATION_WISE_API_ANALYTICS_ENDPOINT =
  "/application-wise-api-consumption-details";
export const API_GET_USER_WISE_API_ANALYTICS_ENDPOINT =
  "/user-wise-api-consumption-details";
export const API_GET_API_LATENCY_REPORT_ANALYTICS_ENDPOINT =
  "/api-latency-metrics-details";
export const API_GET_API_CONSUMPTION_STATUS_CODE_WISE_ANALYTICS_ENDPOINT =
  "/status-code-wise-api-consumption-details";
export const API_GET_APPLICATION_WISE_API_CONSUMPTION_STATUS_CODE_WISE_ANALYTICS_ENDPOINT =
  "/status-code-wise-application-consumption-details";
export const API_GET_USER_WISE_API_CONSUMPTION_STATUS_CODE_WISE_ANALYTICS_ENDPOINT =
  "/status-code-wise-user-consumption-details";
export const API_GET_API_MANAGEMENT_DETAILS_ENDPOINT =
  "/getApiManagementDetails";
export const API_GET_API_CONSUMPTION_TRENDS_ANALYTICS_ENDPOINT =
  "/api-hits-metrics-trend-details";

export const API_CREATE_APPLICATION_ENDPOINT = "/create-application";
export const API_VALIDATE_APP_NAME_ENDPOINT = "/validate-app-name";
export const API_GET_APPLICATION_BY_ID_ENDPOINT = "/application";
export const API_UPDATE_APPLICATION_ENDPOINT = "/application";
export const API_MANAGE_API_SUBSCRIPTIONS_ENDPOINT = "/api-subscriptions";
export const API_MANAGE_API_ACCESS_ENDPOINT = "/user-api-permission";
export const API_APPLICATION_LISTING_ENDPOINT = "/list-application";
export const API_LIST_CONNECTOR_LOGS_ENDPOINT = "/connector-logs";

export const API_GET_CLIENT_CREDENTAILS_ENDPOINT = "/secrets";
export const API_ROTATE_CLIENT_CREDENTAILS_ENDPOINT = "/rotatesecrets";
export const API_FEEDBACK_ENDPOINT = "/feedback";
export const API_META_DATA_ENDPOINT = "/metadata";
export const API_GET_DASHBOARD_METADATA_ENDPOINT = "/user-metadata";
export const API_GET_CAPTCHA_ENDPOINT = "/captcha";
export const API_LIST_SCHEDULED_JOB_EXECUTION_RESULT_ENDPOINT =
  "/scheduled-job-execution-results";
export const API_LIST_WORKFLOW_EXECUTION_RESULT_ENDPOINT =
  "/workflows-execution-results";
export const API_GET_WORKFLOW_EXECUTION_RESULT_ENDPOINT =
  "/workflows-execution-results";
export const API_LIST_APIGATEWAY_IDS = "/list-apigateway";
export const API_LIST_APISTAGE_IDS = "/list-apigateway-stage";

/* PORTAL API ENDS */

/* ROUTES STARTS */
export const ROUTE_ROOT = "/";
export const ROUTE_SIGNIN = "/signin";
export const ROUTE_SIGNUP = "/signup";
export const ROUTE_MFASIGNIN = "/mfa";
export const ROUTE_VERIFYOTP = "/verify-otp";
export const ROUTE_EMAILVERIFICATION = "/verify-email";
export const ROUTE_PRODUCT_CATALOGUE = "/product-catalogue";
export const ROUTE_API_CATALOGUE = "/api-catalogue";
export const ROUTE_SETPASSWORD = "/set-password";
export const ROUTE_FORGOTPASSWORD = "/forgot-password";
export const ROUTE_LOGOUT = "/logout";

export const ROUTE_DASHBOARD = "/dashboard";
export const ROUTE_APPLICATIONS = "/applications";
export const ROUTE_LISTAPI = "/list-api";
export const ROUTE_APIS = "/apis";
export const ROUTE_PROFILE = "/profile";
export const ROUTE_SETTINGS = "/settings";
export const ROUTE_FEEDBACK = "/feedback";
export const ROUTE_APIDOCUMENT = "/apidocument/:apiId";

export const ROUTE_TNC = "?tnc=true";
export const ROUTE_FAQS = "/faqs";
export const ROUTE_CONNECTORLOGS = "/connectorlogs";
export const ROUTE_REPORTS = "/reports";
export const ROUTE_CUSTOMER_DOMAIN_MANAGEMENT = "/customer-endpoints";
export const ROUTE_USERS = "/users";
export const ROUTE_CREATECATEGORY = "?categorymodal=new";
export const ROUTE_UPDATECATEGORY = "?categorymodal=";
export const ROUTE_LISTCATEGORIES = "/admin/list-categories";
export const ROUTE_LISTREQUESTAPIS = "/admin/list-request-apis";
export const ROUTE_LISTFEEDBACK = "/admin/list-feedback";
export const ROUTE_ADMINLISTAPIS = "/admin/list-apis";

export const ROUTE_SECRET_MANAGER = "/admin/secret-manager";
export const ROUTE_CERTIFICATE_MANAGER = "/certificate-manager";

export const ROUTE_LIST_WORKFLOW = "/admin/list-workflow";
export const ROUTE_SCHEDULED_JOB = "/admin/scheduled-job";

export const ROUTE_API_GATEWAY = "/admin/api-gateway";

export const ROUTE_UPDATESECRET = "?secretmanagermodal=";
export const ROUTE_CREATESECRET = "?secretmanagermodal=new";

export const ROUTE_UPDATECERTIFICATE = "?certificatemanagermodal=";
export const ROUTE_CREATECERTIFICATE = "?certificatemanagermodal=new";

export const ROUTE_UPDATEAPIGATEWAYSTAGE = "/admin/api-gateway-setup/:pageMode";

export const ROUTE_CREATEAPIGATEWAYSTAGE =
  "/admin/api-gateway-setup/:pageMode/:gatewayId?";

export const ROUTE_CREATE_WORKFLOWS = "?workflowsmodal=new";
export const ROUTE_UPDATE_WORKFLOWS = "?workflowsmodal=";
export const ROUTE_WORKFLOWS_WORKSPACE =
  "/admin/workflow/workspace/:workflowId";

export const ROUTE_LISTPORTALUSERS = "/portal/list-users";
export const ROUTE_LISTADMINUSERS = "/admin/list-users";
export const ROUTE_LISTSCHEDULED_JOBS = "/admin/scheduled-job";
export const ROUTE_LISTAPI_GATEWAY = "/admin/api-gateway";

export const ROUTE_SETUPAPI = "/admin/api-setup/:apiId?";
export const ROUTE_SETUPUSER = "/admin/user-setup/:userId?";
export const ROUTE_SETUPSCHEDULED_JOB =
  "/admin/scheduled-job-setup/:pageMode/:jobId?";

export const ROUTE_SETUPAPI_GATEWAY =
  "/admin/api-gateway-setup/:pageMode/:gatewayId?";

export const ROUTE_LISTPORTALUSERSAPPLICATION =
  "/admin/users/application/:userId?";
export const ROUTE_LISTAPIACCESSREQUEST =
  "/admin/list-api-access-request/:userId?";
export const ROUTE_GIVECREDITS = "?creditsmodal=:userId&name=:userName";
export const ROUTE_API_LATENCY = "/apilatency";
/* ROUTES ENDS */

export const OPEN_ROUTES = [
  ROUTE_ROOT,
  ROUTE_FAQS,
  ROUTE_CONNECTORLOGS,
  ROUTE_CUSTOMER_DOMAIN_MANAGEMENT,
  ROUTE_SIGNIN,
  ROUTE_MFASIGNIN,
  ROUTE_SIGNUP,
  ROUTE_VERIFYOTP,
  ROUTE_EMAILVERIFICATION,
  ROUTE_PRODUCT_CATALOGUE,
  ROUTE_API_CATALOGUE,
  ROUTE_SETPASSWORD,
  ROUTE_FORGOTPASSWORD,
  ROUTE_LOGOUT,
  ROUTE_FEEDBACK,
  ROUTE_TNC,
];

export const AUTH_ROUTES = [
  ROUTE_SIGNIN,
  ROUTE_MFASIGNIN,
  ROUTE_SIGNUP,
  ROUTE_VERIFYOTP,
  ROUTE_EMAILVERIFICATION,
  ROUTE_PRODUCT_CATALOGUE,
  ROUTE_API_CATALOGUE,
  ROUTE_SETPASSWORD,
  ROUTE_FORGOTPASSWORD,
  ROUTE_LOGOUT,
];

export const FOOTER_HIDDEN_ROUTES = [
  ROUTE_WORKFLOWS_WORKSPACE.replace(":workflowId", ""),
];

export const APPLICATION_LINKS = {
  CONTACT_US: "https://www.fedfina.com/support",
  ABOUT_US: "https://www.fedfina.com/about-us",
  PRIVACY_POLICY: "https://fedfina.com/privacypolicy",
};

export const FEEDBACK_TYPES = [
  { label: "Suggestions", value: "Suggestions" },
  { label: "API Testing", value: "API Testing" },
  { label: "Application Creation", value: "Application Creation" },
  { label: "URL Testing", value: "URL Testing" },
  { label: "Others", value: "Others" },
];

export const PAGE_MODES = {
  READ: "READ",
  CREATE: "CREATE",
  EDIT: "EDIT",
};

export const COMMON_FILTERS = {
  limit: 20,
  page: 1,
  sort: {},
};

export const API_DOCUMENT_MODES = {
  REVIEW: "REVIEW",
  VIEW: "VIEW",
};

/* JSON PRETIFYY THEME CONFIG STARTS */
export const JSON_PRETIFYY_THEME = {
  main: "line-height:1.6;color:var(--lightest-grey);background:var(--white);margin-bottom:0;",
  key: "color:var(--lightest-grey);",
  string: "color:var(--lightest-grey);",
  value: "color:var(--lightest-grey);",
  boolean: "color:var(--lightest-grey);",
  error:
    "line-height:1.6;color:var(--lightest-grey);background:var(--white);margin-bottom:0;",
};
export const JSON_PRETIFYY_PLAIN_THEME = {
  main: "line-height:1.6;background:rgb(242,242,242);color: #545b64;margin-bottom:0; padding:1rem; border-radius: 3px;",
  key: "color:#545b64;",
  string: "color:#1d8102;",
  value: "color:#d13212;",
  boolean: "color:#ec7211;",
};
/* JSON PRETIFYY THEME CONFIG ENDS */

export const POONAWALLA_CUSTOMER_TYPES = [
  {
    label: "Agent",
    value: "AGENT",
  },
  {
    label: "Partner",
    value: "PARTNER",
  },
  {
    label: "Broker",
    value: "BROKER",
  },
];

export const POONAWALLA_ADMIN_STATUS_TYPES = [
  {
    label: "Active",
    value: "ACTIVE",
  },
  {
    label: "Inactive",
    value: "INACTIVE",
  },
];

export const POONAWALLA_USER_STATUS_TYPES = [
  {
    label: "Active",
    value: "ACTIVE",
  },
  {
    label: "Inactive",
    value: "INACTIVE",
  },
  {
    label: "Rejected",
    value: "REJECTED",
  },
];

export const POONAWALLA_USER_TYPES = [
  {
    label: "Corportate",
    value: "CORPORATE",
  },
  {
    label: "Individual",
    value: "INDIVIDUAL",
  },
];

export const POONAWALLA_ADMIN_TYPES = [
  {
    label: "Admin",
    value: "ADMIN",
  },
  {
    label: "Maker",
    value: "MAKER",
  },
  {
    label: "Checker",
    value: "CHECKER",
  },
  {
    label: "Approver",
    value: "APPROVER",
  },
];

export const POONAWALLA_API_SCOPES = [
  {
    label: "Public",
    value: "PUBLIC",
  },
  {
    label: "Private",
    value: "PRIVATE",
  },
];

export const _API_SCOPES = [
  {
    label: "Public",
    value: "PUBLIC",
  },
  {
    label: "Private",
    value: "PRIVATE",
  },
];

export const POONAWALLA_API_FORMAT = [
  {
    label: "SOAP",
    value: "SOAP",
  },
  {
    label: "REST",
    value: "REST",
  },
];

export const POONAWALLA_API_METHOD = [
  {
    label: "GET",
    value: "GET",
  },
  {
    label: "POST",
    value: "POST",
  },
  {
    label: "PUT",
    value: "PUT",
  },
  {
    label: "PATCH",
    value: "PATCH",
  },
  {
    label: "DELETE",
    value: "DELETE",
  },
];

export const POONAWALLA_ORCHESTRATOR_API_METHOD = [
  {
    label: "GET",
    value: "GET",
  },
  {
    label: "POST",
    value: "POST",
  },
  {
    label: "PUT",
    value: "PUT",
  },
  {
    label: "PATCH",
    value: "PATCH",
  },
  {
    label: "DELETE",
    value: "DELETE",
  },
];

export const SQS_ACTION = [
  {
    label: "SEND MESSAGE",
    value: "SEND_MESSAGE",
  },
  {
    label: "READ MESSAGES",
    value: "READ_MESSAGES",
  },
  {
    label: "PURGE QUEUE",
    value: "PURGE_QUEUE",
  },
  {
    label: "LIST QUEUES",
    value: "LIST_QUEUES",
  },
  {
    label: "DELETE MESSAGE",
    value: "DELETE_MESSAGE",
  },
];

export const REDIS_ACTION = [
  {
    label: "GET",
    value: "GET",
  },
  {
    label: "SET",
    value: "SET",
  },
  {
    label: "DELETE",
    value: "DELETE",
  },
  {
    label: "FLUSH ALL",
    value: "FLUSHALL",
  },
];

export const REDIS_KEY_TYPE = [
  {
    label: "STRING",
    value: "STRING",
  },
  {
    label: "LIST",
    value: "LIST",
  },
  {
    label: "JSON",
    value: "JSON",
  },
];

export const COUNTRY_CODES = [
  {
    label: "+91",
    value: "+91",
  },
  {
    label: "+92",
    value: "+92",
  },
  {
    label: "+1",
    value: "+1",
  },
  {
    label: "+44",
    value: "+44",
  },
];

export const RESET_PASSWORD_TYPES = {
  NEW_PASSWORD_REQUIRED: "new-password-required",
  FORGOT_PASSWORD: "forgot-password",
  CHANGE_PASSWORD: "change-password",
};

export const POONAWALLA_USER_ROLES_TYPES = {
  ADMIN: "ADMIN",
  MAKER: "MAKER",
  CHECKER: "CHECKER",
  APPROVER: "APPROVER",
  NORMAL_USER: "NORMAL_USER",
  aliases: {
    ADMIN: "ADMIN",
    MAKER: "MAKER",
    CHECKER: "CHECKER",
    APPROVER: "APPROVER",
    CORPORATE: "NORMAL_USER",
    INDIVIDUAL: "NORMAL_USER",
  },
  types: {
    ADMIN: "ADMIN",
    MAKER: "MAKER",
    CHECKER: "CHECKER",
    APPROVER: "APPROVER",
    CORPORATE: "CORPORATE",
    INDIVIDUAL: "INDIVIDUAL",
  },
  highPrivileged: {
    ADMIN: "ADMIN",
    MAKER: "MAKER",
    CHECKER: "CHECKER",
    APPROVER: "APPROVER",
  },
  lowPrivileged: {
    CORPORATE: "NORMAL_USER",
    INDIVIDUAL: "NORMAL_USER",
  },
};

export const POONAWALLA_APPLICATION_ENVIRONMENTS_TYPES = [
  {
    label: "Sandbox",
    value: "SANDBOX",
  },
  {
    label: "UAT",
    value: "UAT",
  },
  {
    label: "Production",
    value: "PRODUCTION",
  },
];

export const POONAWALLA_APPLICATION_AUTHENTICATION_TYPES = [
  {
    label: "Atlas Authentication",
    value: "ATLAS_AUTH",
  },
  {
    label: "No Authentication",
    value: "NO_AUTH",
  },
];

export const POONAWALLA_SECRETS_ENVIRONMENTS_TYPES = [
  {
    label: "Sandbox",
    value: "SANDBOX",
  },
  {
    label: "UAT",
    value: "UAT",
  },
  {
    label: "Production",
    value: "PRODUCTION",
  },
];

export const REQUEST_HEADER_CONFIGURATION_ACTIONS = [
  {
    label: "Set",
    value: "SET",
  },
  {
    label: "Rename",
    value: "RENAME",
  },
  {
    label: "Filter",
    value: "FILTER",
  },
];
export const REQUEST_HEADER_CONFIGURATION_BEHAVIOR = [
  {
    label: "Overwrite",
    value: "OVERWRITE",
  },
  {
    label: "Skip",
    value: "SKIP",
  },
  {
    label: "Append",
    value: "APPEND",
  },
];

export const REQUEST_HEADER_CONFIGURATION_TYPES = [
  {
    label: "Allow",
    value: "ALLOW",
  },
  {
    label: "Block",
    value: "BLOCK",
  },
];

export const POONAWALLA_WORKFLOWS_ENVIRONMENTS_TYPES = [
  {
    label: "Sandbox",
    value: "SANDBOX",
  },
  {
    label: "UAT",
    value: "UAT",
  },
  {
    label: "Production",
    value: "PRODUCTION",
  },
];

export const POONAWALLA_SCHEDULED_JOBS_ENVIRONMENTS_TYPES = [
  {
    label: "Sandbox",
    value: "SANDBOX",
  },
  {
    label: "UAT",
    value: "UAT",
  },
  {
    label: "Production",
    value: "PRODUCTION",
  },
];

export const POONAWALLA_WORKFLOWS_STATUS_TYPES = [
  {
    label: "Active",
    value: "ACTIVE",
  },
  {
    label: "Inactive",
    value: "INACTIVE",
  },
];

export const POONAWALLA_SCHEDULED_JOBS_STATUS_TYPES = [
  {
    label: "Active",
    value: "ACTIVE",
  },
  {
    label: "Inactive",
    value: "INACTIVE",
  },
];

export const POONAWALLA_SECRETS_STATUS_TYPES = [
  {
    label: "Active",
    value: "ACTIVE",
  },
  {
    label: "Inactive",
    value: "INACTIVE",
  },
];

export const _API_GATEWAY_TYPES = [
  {
    label: "REST",
    value: "REST",
  },
  // {
  //   label: "HTTP",
  //   value: "HTTP",
  // },
  // {
  //   label: "WEB SOCKET",
  //   value: "WEB_SOCKET",
  // },
];

export const NAV_ROUTES_FOR_POONAWALLA_USERS = [
  {
    title: "Dashboard",
    to: ROUTE_DASHBOARD,
    activeFor: [ROUTE_DASHBOARD],
  },
  {
    title: "Application",
    to: ROUTE_APPLICATIONS,
    activeFor: [ROUTE_APPLICATIONS],
  },
  {
    title: "APIs",
    to: ROUTE_APIS,
    activeFor: [ROUTE_APIS, ROUTE_LISTAPI, ROUTE_APIDOCUMENT],
  },
  {
    title: "FAQs",
    to: ROUTE_FAQS,
    activeFor: [ROUTE_FAQS],
  },
  {
    title: "Connector Logs",
    to: ROUTE_CONNECTORLOGS,
    activeFor: [ROUTE_CONNECTORLOGS],
  },
];

export const NAV_ROUTES_FOR_POONAWALLA_ADMINS = [
  {
    title: "Dashboard",
    to: ROUTE_DASHBOARD,
    activeFor: [ROUTE_DASHBOARD],
  },
  {
    title: "APIs",
    to: ROUTE_ADMINLISTAPIS,
    activeFor: [
      ROUTE_ADMINLISTAPIS,
      ROUTE_LISTAPI,
      ROUTE_APIDOCUMENT,
      ROUTE_SETUPAPI,
    ],
  },
  {
    title: "Workflows",
    to: ROUTE_LIST_WORKFLOW,
    activeFor: [ROUTE_LIST_WORKFLOW, ROUTE_WORKFLOWS_WORKSPACE],
  },
  {
    title: "Scheduled Jobs",
    to: ROUTE_SCHEDULED_JOB,
    activeFor: [ROUTE_SCHEDULED_JOB, ROUTE_SETUPSCHEDULED_JOB],
  },
  {
    title: "Secret Manager",
    to: ROUTE_SECRET_MANAGER,
    activeFor: [ROUTE_SECRET_MANAGER],
  },
  {
    title: "Certificate Manager",
    to: ROUTE_CERTIFICATE_MANAGER,
    activeFor: [ROUTE_CERTIFICATE_MANAGER],
  },
  {
    title: "API Gateways",
    to: ROUTE_API_GATEWAY,
    activeFor: [ROUTE_API_GATEWAY, ROUTE_SETUPAPI_GATEWAY],
  },
  {
    title: "Portal Users",
    to: ROUTE_LISTPORTALUSERS,
    activeFor: [ROUTE_LISTPORTALUSERS],
  },
  {
    title: "Fedfina Users",
    to: ROUTE_LISTADMINUSERS,
    activeFor: [ROUTE_LISTADMINUSERS, ROUTE_SETUPUSER],
  },
  {
    title: "Applications",
    to: ROUTE_LISTPORTALUSERSAPPLICATION.replace(":userId?", ""),
    activeFor: [ROUTE_LISTPORTALUSERSAPPLICATION],
  },
  {
    title: "Category",
    to: ROUTE_LISTCATEGORIES,
    activeFor: [ROUTE_LISTCATEGORIES],
  },
  {
    title: "Customer Endpoints",
    to: ROUTE_CUSTOMER_DOMAIN_MANAGEMENT,
    activeFor: [ROUTE_CUSTOMER_DOMAIN_MANAGEMENT],
  },
  {
    title: "Request",
    to: ROUTE_LISTAPIACCESSREQUEST.replace(":userId?", ""),
    activeFor: [ROUTE_LISTAPIACCESSREQUEST],
  },
  {
    title: "Connector Logs",
    to: ROUTE_CONNECTORLOGS,
    activeFor: [ROUTE_CONNECTORLOGS],
  },
  {
    title: "Reports",
    to: ROUTE_REPORTS,
    activeFor: [ROUTE_REPORTS],
  },
  {
    title: "Feedback",
    to: ROUTE_LISTFEEDBACK,
    activeFor: [ROUTE_LISTFEEDBACK],
  },
];

export const NAV_ROUTES_FOR_POONAWALLA_MAKERS = [
  {
    title: "Dashboard",
    to: ROUTE_DASHBOARD,
    activeFor: [ROUTE_DASHBOARD],
  },
  {
    title: "APIs",
    to: ROUTE_ADMINLISTAPIS,
    activeFor: [
      ROUTE_ADMINLISTAPIS,
      ROUTE_LISTAPI,
      ROUTE_APIDOCUMENT,
      ROUTE_SETUPAPI,
    ],
  },
  {
    title: "Workflows",
    to: ROUTE_LIST_WORKFLOW,
    activeFor: [ROUTE_LIST_WORKFLOW, ROUTE_WORKFLOWS_WORKSPACE],
  },
  {
    title: "Scheduled Jobs",
    to: ROUTE_SCHEDULED_JOB,
    activeFor: [ROUTE_SCHEDULED_JOB, ROUTE_SETUPSCHEDULED_JOB],
  },
  {
    title: "Secret Manager",
    to: ROUTE_SECRET_MANAGER,
    activeFor: [ROUTE_SECRET_MANAGER],
  },
  {
    title: "Certificate Manager",
    to: ROUTE_CERTIFICATE_MANAGER,
    activeFor: [ROUTE_CERTIFICATE_MANAGER],
  },
  {
    title: "API Gateways",
    to: ROUTE_API_GATEWAY,
    activeFor: [ROUTE_API_GATEWAY, ROUTE_SETUPAPI_GATEWAY],
  },
  {
    title: "Portal Users",
    to: ROUTE_LISTPORTALUSERS,
    activeFor: [ROUTE_LISTPORTALUSERS],
  },
  {
    title: "Applications",
    to: ROUTE_LISTPORTALUSERSAPPLICATION.replace(":userId?", ""),
    activeFor: [ROUTE_LISTPORTALUSERSAPPLICATION],
  },
  {
    title: "Category",
    to: ROUTE_LISTCATEGORIES,
    activeFor: [ROUTE_LISTCATEGORIES],
  },
  {
    title: "Connector Logs",
    to: ROUTE_CONNECTORLOGS,
    activeFor: [ROUTE_CONNECTORLOGS],
  },
];

export const NAV_ROUTES_FOR_POONAWALLA_CHECKERS = [
  ...NAV_ROUTES_FOR_POONAWALLA_MAKERS,
  {
    title: "Request",
    to: ROUTE_LISTREQUESTAPIS,
    activeFor: [ROUTE_LISTREQUESTAPIS],
  },
];

export const NAV_ROUTES_FOR_POONAWALLA_APPROVER = [
  {
    title: "Dashboard",
    to: ROUTE_DASHBOARD,
    activeFor: [ROUTE_DASHBOARD],
  },
  {
    title: "Portal Users",
    to: ROUTE_LISTPORTALUSERS,
    activeFor: [ROUTE_LISTPORTALUSERS],
  },
  {
    title: "Request",
    to: ROUTE_LISTAPIACCESSREQUEST.replace(":userId?", ""),
    activeFor: [ROUTE_LISTAPIACCESSREQUEST],
  },
];

export const ROUTES_ROLES_MAPPER = {
  NORMAL_USER: NAV_ROUTES_FOR_POONAWALLA_USERS,
  ADMIN: NAV_ROUTES_FOR_POONAWALLA_ADMINS,
  MAKER: NAV_ROUTES_FOR_POONAWALLA_MAKERS,
  CHECKER: NAV_ROUTES_FOR_POONAWALLA_CHECKERS,
  APPROVER: NAV_ROUTES_FOR_POONAWALLA_APPROVER,
};

export const NAV_DROPDOWN_CONFIG_USERS = [
  {
    title: "View Profile",
    to: ROUTE_PROFILE,
  },
  {
    title: "Change Password",
    to: `${ROUTE_SETPASSWORD}?type=${RESET_PASSWORD_TYPES.CHANGE_PASSWORD}`,
  },
  {
    title: "Settings",
    to: ROUTE_SETTINGS,
  },
  {
    title: "Logout",
    to: ROUTE_LOGOUT,
  },
];

export const NAV_DROPDOWN_CONFIG_ADMINS = [
  {
    title: "View Profile",
    to: ROUTE_PROFILE,
  },
  {
    title: "Change Password",
    to: `${ROUTE_SETPASSWORD}?type=${RESET_PASSWORD_TYPES.CHANGE_PASSWORD}`,
  },
  {
    title: "Logout",
    to: ROUTE_LOGOUT,
  },
];

export const NAV_DROPDOWN_ROLES_MAPPER = {
  NORMAL_USER: NAV_DROPDOWN_CONFIG_USERS,
  ADMIN: NAV_DROPDOWN_CONFIG_ADMINS,
  MAKER: NAV_DROPDOWN_CONFIG_ADMINS,
  CHECKER: NAV_DROPDOWN_CONFIG_ADMINS,
  APPROVER: NAV_DROPDOWN_CONFIG_ADMINS,
};

export const POONAWALLA_DIALOG_TYPES = {
  TOASTER: "TOASTER",
  FIELD: "FIELD",
  MODAL: "MODAL",
};

export const STATUS_TO_TEXT_MAPPER = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  REJECTED: "Rejected",
  CORRECTION_REQUIRED: "Correction Required",
  DELETED: "Deleted",
  DRAFT: "Draft",
};

export const DUMMY_HEADER_FIELD_OBJECT = {
  name: "",
  description: "",
  mandatory: false,
  value: "",
  defaultvalue: "",
  environment: "",
  secretManagerKey: false,
};

export const DUMMY_QUERY_FIELD_OBJECT = {
  name: "",
  description: "",
  mandatory: false,
};

export const DUMMY_RESPONSE_FIELD_OBJECT = {
  name: "",
  description: "",
  datatype: "",
};

export const DUMMY_REQUEST_FIELD_OBJECT = {
  name: "",
  description: "",
  mandatory: false,
  datatype: "",
};

export const DUMMY_RESPONSE_DATA = {
  success: false,
  type: "",
  code: "",
  description: "",
  content: "",
};

export const DUMMY_REQUEST_DATA = {
  name: "",
  type: "",
  description: "",
  content: "",
};
export const DUMMY_HEADER_TRANSFORMATION_CONFIGURATION = {
  action: "",
  behaviour: "",
  name: "",
  new_name: "",
  type: "",
  values: [],
};

export const SAMPLE_REQUEST_HEADER_TRANSFORMATION_CONFIGURATION = [];

export const SAMPLE_RESPONSE_HEADER_TRANSFORMATION_CONFIGURATION = [
  {
    action: "SET",
    behaviour: "OVERWRITE",
    name: "access-control-allow-methods",
    new_name: "",
    type: "",
    values: [
      {
        label: "OPTIONS, HEAD",
        value: "OPTIONS, HEAD",
      },
    ],
  },
  {
    action: "FILTER",
    behaviour: "",
    name: "",
    new_name: "",
    type: "BLOCK",
    values: [
      {
        label: "server",
        value: "server",
      },
      {
        label: "x-powered-by",
        value: "x-powered-by",
      },
    ],
  },
];

export const DUMMY_REQUEST_BODY_VALIDATION_DATA = {
  type: "",
  content: "",
};

export const REQUEST_RESPONSE_TYPES = [
  {
    label: "Form Data",
    value: "multipart/form-data",
  },
  {
    label: "JSON",
    value: "application/json",
  },
  {
    label: "XML",
    value: "application/xml",
  },
  {
    label: "Text",
    value: "text/plain",
  },
  {
    label: "x-www-form-encoded",
    value: "application/x-www-form-urlencoded",
  },
  {
    label: "HTML",
    value: "text/html",
  },
];

export const FORM_DATA_REQUEST_BODY_TYPES = [
  "multipart/form-data",
  "application/x-www-form-urlencoded",
];

export const TYPES_TO_BE_EXCLUDED_FOR_REQUESTS = ["text/html"];

export const TYPES_TO_BE_EXCLUDED_FOR_RESPONSES = [
  "multipart/form-data",
  "application/x-www-form-urlencoded",
];

export const SCHEDULEDJOBS_TYPES_TO_BE_EXCLUDED_FOR_REQUESTS_BODY = [
  "text/html",
  "application/x-www-form-urlencoded",
  "multipart/form-data",
];

export const TYPES_TO_BE_EXCLUDED_FOR_EMAIL_BODY = [
  "application/x-www-form-urlencoded",
  "multipart/form-data",
  "application/json",
  "application/xml",
];

export const TYPES_TO_BE_EXCLUDED_FOR_REQUESTS_BODY_VALIDATION_SCHEMA = [
  "application/xml",
  "text/html",
  "text/plain",
  "application/xml",
];

export const REACT_ACE_MODES = {
  PLAIN_TEXT: "plain_text",
  JSON: "json",
  XML: "xml",
  HTML: "html",
};

export const HTTP_SNIPPET_LANGUAGES_SUPPORTED = {
  JAVASCRIPT: {
    type: "JAVASCRIPT",
    label: "Javascript",
    snippetTarget: ["javascript", "fetch"],
    mode: "javascript",
  },
  PYTHON: {
    type: "PYTHON",
    label: "Python",
    snippetTarget: ["python", "python3"],
    mode: "python",
  },
  PHP: {
    type: "PHP",
    label: "PHP",
    snippetTarget: ["php", "curl"],
    mode: "php",
  },
  JAVA: {
    type: "JAVA",
    label: "Java",
    snippetTarget: ["java", "unirest"],
    mode: "java",
  },
  C_SHARP: {
    type: "C_SHARP",
    label: "C#",
    snippetTarget: ["csharp", "restsharp"],
    mode: "csharp",
  },
  CURL: {
    type: "CURL",
    label: "Curl",
    snippetTarget: ["shell", "curl"],
    mode: "markdown",
  },
};

export const ACE_CONTENT_TYPE_TO_MODE_MAPPER = {
  "multipart/form-data": REACT_ACE_MODES.PLAIN_TEXT,
  "application/json": REACT_ACE_MODES.JSON,
  "application/xml": REACT_ACE_MODES.XML,
  "text/xml": REACT_ACE_MODES.XML,
  "text/plain": REACT_ACE_MODES.PLAIN_TEXT,
  "text/html": REACT_ACE_MODES.HTML,
};

export const API_SUPPORTED_DATATYPES = [
  {
    label: "String",
    value: "string",
  },
  {
    label: "Integer",
    value: "integer",
  },
  {
    label: "Number",
    value: "number",
  },
  {
    label: "Boolean",
    value: "boolean",
  },
  {
    label: "Array",
    value: "array",
  },
  {
    label: "Object",
    value: "object",
  },
];

export const API_SUPPORTED_RESPONSETYPES = [
  { label: "Success", value: true },
  { label: "Error", value: false },
];

export const DASHBOARD_WIDGETS_CONFIG = {
  DRAFT_APIS: {
    title: "Draft APIs",
    description: "Total No. APIS awaiting for Approval",
    key: "DRAFT_APIS",
    theme: "dashboard-blue",
    logo: "/assets/svg/poonawalla__dashboardapi.svg",
  },
  ACTIVE_APIS: {
    title: "Active APIs",
    description: "Total No. of Active APIs",
    key: "ACTIVE_APIS",
    theme: "dashboard-green",
    logo: "/assets/svg/poonawalla__dashboardapi.svg",
  },
  INACTIVE_APIS: {
    title: "Inactive APIs",
    description: "Total No. of Inactive APIs",
    key: "INACTIVE_APIS",
    theme: "dashboard-red",
    logo: "/assets/svg/poonawalla__dashboardapi.svg",
  },
  REJECTED_APIS: {
    title: "Rejected APIs",
    description: "Total No. of Reject APIs",
    key: "API_SUBSCRIPTIONS",
    theme: "dashboard-red",
    logo: "/assets/svg/poonawalla__dashboardapi.svg",
  },
  CORRECTION_REQUIRED_APIS: {
    title: "APIs Sent for Correction",
    description: "Total No. of APIs Sent for Correction",
    key: "CORRECTION_REQUIRED_APIS",
    theme: "dashboard-blue",
    logo: "/assets/svg/poonawalla__dashboardapi.svg",
  },
  ALL_APIS: {
    title: "APIs Created",
    description: "Total No. of APIs Created",
    key: "ALL_APIS",
    theme: "dashboard-green",
    logo: "/assets/svg/poonawalla__dashboardapi.svg",
  },
  PUBLIC_API_CONSUMPTION: {
    title: "Public API Consumption",
    description: "Total No. of API Hits for Public APIs",
    key: "PUBLIC_API_CONSUMPTION",
    theme: "dashboard-pink",
    logo: "/assets/svg/poonawalla__dashboardapi.svg",
  },
  PRIVATE_API_CONSUMPTION: {
    title: "Private API Consumption",
    description: "Total No. of API Hits for Private APIs",
    key: "PRIVATE_API_CONSUMPTION",
    theme: "dashboard-blue",
    logo: "/assets/svg/poonawalla__dashboardapi.svg",
  },
  APIS_CONSUMPTIONS: {
    title: "API Consumption",
    description: "Total No. of APIs Hits",
    key: "APIS_CONSUMPTIONS",
    theme: "dashboard-pink",
    logo: "/assets/svg/poonawalla__dashboardapi.svg",
  },
  SUCCESSFULL_API_CONSUMPTIONS: {
    title: "Successfull API Consumption",
    description: "Total No. of Successfull APIs Hits",
    key: "SUCCESSFULL_API_CONSUMPTIONS",
    theme: "dashboard-green",
    logo: "/assets/svg/poonawalla__dashboardapi.svg",
  },
  FAILED_API_CONSUMPTIONS: {
    title: "Failed API Subscriptions",
    description: "Total No. of Failed APIs Hit",
    key: "FAILED_API_CONSUMPTIONS",
    theme: "dashboard-red",
    logo: "/assets/svg/poonawalla__dashboardapi.svg",
  },
  APPLICATIONS: {
    title: "Applications",
    description: "Total No. of Application Created",
    key: "APPLICATIONS",
    theme: "dashboard-green",
    logo: "/assets/svg/poonawalla__dashboardapplication.svg",
  },
  API_SUBSCRIPTIONS: {
    title: "API Subscriptions",
    description: "Total No. of APIs Subscribed",
    key: "API_SUBSCRIPTIONS",
    theme: "dashboard-blue",
    logo: "/assets/svg/poonawalla__dashboardapplication.svg",
  },
  API_ACCESS_REQUEST_PENDING: {
    title: "API Request Pending",
    description: "Total No. of APIs Access Request Pending",
    key: "API_ACCESS_REQUEST_PENDING",
    theme: "dashboard-blue",
    logo: "/assets/svg/poonawalla__dashboardapi.svg",
  },
  CORPORATE_USER_ONBOARDED: {
    title: "Corporate Users",
    description: "Corporate Users Registered",
    key: "CORPORATE_USER_ONBOARDED",
    theme: "dashboard-green",
    logo: "/assets/svg/poonawalla__dashboarduser.svg",
  },
  INDIVIDUAL_USER_ONBOARDED: {
    title: "Individual Users",
    description: "Individual Users Registrations",
    key: "INDIVIDUAL_USER_ONBOARDED",
    theme: "dashboard-green",
    logo: "/assets/svg/poonawalla__dashboarduser.svg",
  },
  CORPORATE_USER_REJECTED: {
    title: "Corporate Users Rejected",
    description: "Corporate Users Registrations Rejected",
    key: "CORPORATE_USER_REJECTED",
    theme: "dashboard-red",
    logo: "/assets/svg/poonawalla__dashboarduser.svg",
  },
  INDIVIDUAL_USER_REJECTED: {
    title: "Individual Users Rejected",
    description: "Individual Users Registrations Rejected",
    key: "INDIVIDUAL_USER_REJECTED",
    theme: "dashboard-red",
    logo: "/assets/svg/poonawalla__dashboarduser.svg",
  },
  CORPORATE_USER_PENDING: {
    title: "Corporate Users Awaiting",
    description: "Individual Users awaiting for Onboarding",
    key: "CORPORATE_USER_PENDING",
    theme: "dashboard-blue",
    logo: "/assets/svg/poonawalla__dashboarduser.svg",
  },
  INDIVIDUAL_USER_PENDING: {
    title: "Individual Users Awaiting",
    description: "Individual Users awaiting for Onboarding",
    key: "INDIVIDUAL_USER_PENDING",
    theme: "dashboard-blue",
    logo: "/assets/svg/poonawalla__dashboarduser.svg",
  },
  ADMIN_USER_REGISTERATION: {
    title: "Admins",
    description: "Total No. of Admin",
    key: "ADMIN_USER_REGISTERATION",
    theme: "dashboard-purple",
    logo: "/assets/svg/poonawalla__dashboarduser.svg",
  },
  MAKER_USER_REGISTERATION: {
    title: "Makers",
    description: "Total No. of Makers",
    key: "MAKER_USER_REGISTERATION",
    theme: "dashboard-purple",
    logo: "/assets/svg/poonawalla__dashboarduser.svg",
  },
  CHECKER_USER_REGISTERATION: {
    title: "Checkers",
    description: "Total No. of Checkers",
    key: "CHECKER_USER_REGISTERATION",
    theme: "dashboard-purple",
    logo: "/assets/svg/poonawalla__dashboarduser.svg",
  },
  APPROVER_USER_REGISTERATION: {
    title: "Product Approvers",
    description: "Total No. of Product Approvers",
    key: "APPROVER_USER_REGISTERATION",
    theme: "dashboard-purple",
    logo: "/assets/svg/poonawalla__dashboarduser.svg",
  },
};

export const POONAWALLA_DATA_AGGREGATE_OPTIONS = [
  {
    label: "Minutely",
    value: "minutely",
  },
  {
    label: "Hourly",
    value: "hourly",
  },
  {
    label: "Daily",
    value: "daily",
  },
  {
    label: "Weekly",
    value: "weekly",
  },
  {
    label: "Monthly",
    value: "monthly",
  },
  {
    label: "Yearly",
    value: "yearly",
  },
];

export const COUNTRY_AVAIALBLE = [
  {
    label: "+91",
    value: "+91",
  },
];

export const AUTH_ACTIONS_TYPES = {
  EMAIL_VERIFICATION: "EMAIL_VERIFICATION",
  PHONE_VERIFICATION: "PHONE_VERIFICATION",
  MFA_AUTH: "MFA_AUTH",
  NEW_PASSWORD_REQUIRED: "NEW_PASSWORD_REQUIRED",
  SHOW_MESSAGE: "SHOW_MESSAGE",
};

export const _API_ACCESS_TYPES = {
  PENDING: {
    label: "Pending",
    canResendForApproval: false,
    type: "PENDING",
  },
  APPROVED: {
    label: "Approved",
    canResendForApproval: false,
    type: "APPROVED",
  },
  REJECTED: {
    label: "Rejected",
    canResendForApproval: true,
    type: "REJECTED",
  },
};

export const _USER_STATUS_TYPES = {
  PENDING: {
    label: "Pending",
    type: "PENDING",
  },
  ACTIVE: {
    label: "Active",
    type: "ACTIVE",
  },
  INACTIVE: {
    label: "Inctive",
    type: "INACTIVE",
  },
  REJECTED: {
    label: "Rejected",
    type: "REJECTED",
  },
};

export const POONAWALLA_API_STATUS = [
  {
    label: "Draft",
    value: "DRAFT",
  },
  {
    label: "Active",
    value: "ACTIVE",
  },
  {
    label: "Inactive",
    value: "INACTIVE",
  },
  {
    label: "Rejected",
    value: "REJECTED",
  },
  {
    label: "Correction Required",
    value: "CORRECTION_REQUIRED",
  },
];

export const _APPLICATION_STATUS_TYPES = [
  {
    label: "Active",
    value: "ACTIVE",
  },
  {
    label: "Inactive",
    value: "INACTIVE",
  },
];

export const _CATEGORIES_STATUS_TYPES = [
  {
    label: "Active",
    value: "ACTIVE",
  },
  {
    label: "Inactive",
    value: "INACTIVE",
  },
];

export const _FORMDATA_TABLE_TYPES = { TEXT: "Text", FILE: "File" };

export const _API_EXECUTION_TYPES = {
  WORKFLOW: "WORKFLOW",
  API_PROXY: "API_PROXY",
};

export const _API_ATLAS_AUTHENTICATION_TYPES = [
  {
    name: "x-client-id",
    description: "Client ID",
    mandatory: true,
    value: "xxxxClientId",
    defaultvalue: "",
    environment: "",
    secretManagerKey: false,
  },
  {
    name: "x-client-secret",
    description: "Client Secret",
    mandatory: true,
    value: "xxxxClientSecret",
    defaultvalue: "",
    environment: "",
    secretManagerKey: false,
  },
  {
    name: "x-application-id",
    description: "Application Id",
    mandatory: true,
    value: "xxxxApplicationId",
    defaultvalue: "",
    environment: "",
    secretManagerKey: false,
  },
];
